import React from 'react';
import Avatar from '@mui/material/Avatar';
import NoPlantImage from '../../themes/icons/NoPlantImage';
const classes = {
    root: {
        cursor: 'pointer',
    },
};
export default function AvatarImage({ customClassName, sqaure = false, children, ...other }) {
    return (React.createElement(Avatar, { sx: [customClassName, classes.root], variant: sqaure ? 'square' : 'circular', ...other }, children || React.createElement(NoPlantImage, null)));
}
